/* STEP 6 — Done. Success stamp + summary of what was uploaded + navigation. */
import React from 'react'
import PropTypes from 'prop-types'
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined'
import CheckIcon from '@mui/icons-material/Check'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import {fmtDate} from '../components'

export default function StepDone({U, navigate, onAgain}) {
  const res = U.result || {rate: 0, tat: 0}
  const scheduled = res.effectiveFrom && new Date(res.effectiveFrom) > new Date()
  const title =
    res.rate && res.tat ? 'Rates & TAT uploaded' : res.rate ? 'Rate card uploaded' : 'TAT uploaded'

  const parts = []
  if (res.rate) parts.push('a rate card')
  if (res.tat) parts.push('a TAT file')

  return (
    <div className='card card-pad' style={{maxWidth: 580, margin: '0 auto', textAlign: 'center'}}>
      <div style={{margin: '10px 0 18px'}}>
        <span className='update-stamp'>
          <CheckIcon style={{width: 36, height: 36}} />
        </span>
      </div>
      <h2 style={{margin: '0 0 6px'}}>{title}</h2>
      <p className='muted' style={{margin: '0 0 4px'}}>
        Uploaded {parts.join(' and ')} for <b>{res.code || U.display || U.code}</b>
        {res.prozoId ? (
          <>
            {' '}
            (<span className='mono'>{res.prozoId}</span>)
          </>
        ) : null}
        .
      </p>
      {res.rate ? (
        <p className='muted' style={{margin: 0}}>
          {scheduled ? (
            <>
              The rate card is <b>staged as pending</b> and goes live on <b>{fmtDate(res.effectiveFrom)}</b> via the daily cron.
            </>
          ) : (
            <>The rate card replaced the current one immediately.</>
          )}
        </p>
      ) : null}

      <div style={{marginTop: 20, display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap'}}>
        <button type='button' className='btn btn-primary' onClick={() => navigate('/supply/courier-codes')}>
          <VisibilityOutlinedIcon style={{width: 16, height: 16}} />
          View Courier Codes
        </button>
        <button type='button' className='btn' onClick={() => navigate('/supply/partners')}>
          Back to Directory
        </button>
        <button type='button' className='btn btn-ghost' onClick={onAgain}>
          <SyncOutlinedIcon style={{width: 15, height: 15}} />
          Update another code
        </button>
      </div>
    </div>
  )
}

StepDone.propTypes = {
  U: PropTypes.object,
  navigate: PropTypes.func,
  onAgain: PropTypes.func,
}
